export interface ProviderType {
  displayName: string;
  identityProvider: string | {custom: string};
}

export interface ProvidersType {
  [key: string]: ProviderType;
}

export const providers: ProvidersType = {
  discord: {
    displayName: "Discord",
    identityProvider: {custom: "Discord"}
  },
  facebook: {
    displayName: "Facebook",
    identityProvider: "Facebook"
  },
  google: {
    displayName: "Google",
    identityProvider: "Google"
  },
  twitch: {
    displayName: "Twitch",
    identityProvider: {custom: "Twitch"}
  },
  twitter: {
    displayName: "X",
    identityProvider: "Twitter"
  },
  ultra: {
    displayName: "Ultra",
    identityProvider: {custom: "Ultra"}
  }
};

export type ProviderKeys = keyof typeof providers;
